import toast from 'react-hot-toast';
import {
    FETCH_RELATIONS_REQUEST,
    GET_RELATIONS,
    RELATIONS_ERROR,
    GET_SINGLE_RELATION,
    GET_FILTERED_RELATIONS,
    PUT_FILTERED_RELATIONS,
    PUT_DEACTIVATED_RELATIONS,
    PUT_REACTIVATED_RELATIONS,
    GET_SOME_RELATIONS,
    GET_SOME_PARTNER_RELATIONS,
    GET_CURRENT_OFFERINGS,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const fetchRelationsRequest = () => {
        return {
            type: FETCH_RELATIONS_REQUEST,
        };
    };

    const getRelations = (relations) => {
        return {
            type: GET_RELATIONS,
            payload: relations,
        };
    };

    const getSomeRelations = (someRelations) => {
        return {
            type: GET_SOME_RELATIONS,
            payload: someRelations,
        };
    };

    const getSomePartnerRelations = (someRelations) => {
        return {
            type: GET_SOME_PARTNER_RELATIONS,
            payload: someRelations,
        };
    };

    const getSingleRelation = (singleRelation) => {
        return {
            type: GET_SINGLE_RELATION,
            payload: singleRelation,
        };
    };

    const relationsError = (error) => {
        return {
            type: RELATIONS_ERROR,
            payload: error,
        };
    };

    const putFilteredRelations = (filteredRelations) => {
        return {
            payload: filteredRelations,
            type: PUT_FILTERED_RELATIONS,
        };
    };

    const putReactivatedRelations = (reactivatedRelation) => {
        return {
            payload: reactivatedRelation,
            type: PUT_REACTIVATED_RELATIONS,
        };
    };

    const putDeactivatedRelations = (deactivatedRelation) => {
        return {
            payload: deactivatedRelation,
            type: PUT_DEACTIVATED_RELATIONS,
        };
    };

    const getFilteredRelations = (filteredRelations) => {
        return {
            type: GET_FILTERED_RELATIONS,
            payload: filteredRelations,
        };
    };

    const getCurrentOfferings = (currentOfferings) => {
        return {
            type: GET_CURRENT_OFFERINGS,
            payload: currentOfferings,
        };
    };

    const getPracticeRelations = (practiceId) => async () =>
        axiosCall.get('practices/' + practiceId + '/relations');

    const getPracticeRelationbyOfferingId = (partnerOfferingId, partnerCustomId = '', convertAttachments) => async () =>
        await axiosCall.get(`practices/${partnerOfferingId}/relations/detail?partnerCustomId=${partnerCustomId}&convertAttachments=${convertAttachments}`);

    const fetchRelations = (practiceId) => {
        return async (dispatch) => {
            try {
                dispatch(fetchRelationsRequest);
                var response = await axiosCall.get(
                    `practices/${practiceId}/relations`
                );
                const relations = response.data.data;
                dispatch(getRelations(relations));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));
            }
        };
    };

    const fetchSingleRelation = (practiceId) => {
        return async (dispatch) => {
            try {
                dispatch(fetchRelationsRequest);
                var response = await axiosCall.get(
                    `Practices/${practiceId}/relations`
                );
                const singleRelation = response.data.data;
                dispatch(getSingleRelation(singleRelation));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));
            }
        };
    };

    const saveRelation = (
        practiceId,
        partnerOfferingId,
        customPartnerId = '',
        convertAttachments = false,
    ) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.post(
                    `Practices/${practiceId}/relations?offeringId=${partnerOfferingId}&customPartnerId=${customPartnerId}&convertAttachments=${convertAttachments}`
                );
                return response.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));

                toast(() => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: Something occurred during save relations!
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
            }
        };
    };

    const updateRelation = (
        practiceId,
        partnerOfferingId,
        customPartnerId = '',
        convertAttachments = false,
    ) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.patch(
                    `Practices/${practiceId}/relations?offeringId=${partnerOfferingId}&customPartnerId=${customPartnerId}&convertAttachments=${convertAttachments}`
                );
                return response.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));
            }
        };
    };

    const batchSaveRelations = (practiceId, offeringIds = []) => {
        return async (dispatch) => {
            try {
                await axiosCall.post(
                    `practices/${practiceId}/relations/batch`,
                    {
                        offeringIds: offeringIds,
                    }
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));
            }
        };
    };

    const batchPatchRelations = (practiceId, relations = []) => {
        return async (dispatch) => {
            try {
                await axiosCall.patch(`relations/${practiceId}/batch`, {
                    relations: relations,
                });
            } catch (e) {
                console.error(e);
            }
        };
    };

    const deletePracticeOffering = (relationId, practiceId) => {
        return async (dispatch) => {
            try {
                var response = await axiosCall.delete(
                    `relations/${relationId}`
                );
                dispatch(fetchSingleRelation(practiceId));
                return response.data.data;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(relationsError(errorMsg));
            }
        };
    };

    return {
        batchPatchRelations,
        batchSaveRelations,
        deletePracticeOffering,
        fetchRelations,
        fetchRelationsRequest,
        fetchSingleRelation,
        getCurrentOfferings,
        getFilteredRelations,
        getPracticeRelations,
        getPracticeRelationbyOfferingId,
        getRelations,
        getSingleRelation,
        getSomePartnerRelations,
        getSomeRelations,
        putDeactivatedRelations,
        putFilteredRelations,
        putReactivatedRelations,
        relationsError,
        saveRelation,
        updateRelation,
    };
};

export default initActions;
